import { useState, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import List from 'src/componentes/list/tree';
import ListColumn from 'src/componentes/list/list-column';
import useAuth from 'src/hooks/useAuth';
import ConsequenciaEventoRiscoEdit from './edit';

const ConsequenciasEventoRiscoList = (props) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();
  const { disabled, refreshAfterRemove, eventoRiscoId, model, refreshCount } =
    props;

  const [saved, setSaved] = useState(-1);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    setSaved((prev) => prev + 1);
  }, [refreshAfterRemove]);

  return (
    <List
      editComponent={ConsequenciaEventoRiscoEdit}
      url="/RiscoConsequencias"
      showDelete={true}
      showExportItem={false}
      showExport={false}
      hierarchy={true}
      valueField="descricao"
      saved={saved}
      showNew={!disabled}
      showMenu={!disabled}
      parameters={{ eventoRiscoId: eventoRiscoId }}
      afterSave={refreshCount}
      afterDelete={refreshCount}
      local
      modelValue={model.value}
      dataSource={model.value}
      {...props}
      resources={resources}
    >
      <ListColumn
        headerText={intl.formatMessage({ id: 'descricao' })}
        tree={true}
        valueField="descricao"
        required
      />
    </List>
  );
};

export default ConsequenciasEventoRiscoList;
